import  React from 'react';
import _ from 'underscore';

import { LoadingLinear } from './loading.jsx';

import Retry from '../common/Retry.jsx';
import { SERVER_TIMED_OUT } from '../../helpers/constants.js';
const MAX_NUMBER_OF_ROWS = 10;

/* Infobox data format:
  data = [
    { name: "something", value: "some value" },
    { name: "something else", value: "some other value"},
    { name: "some warning", value: "warning value", warning: true},
    { name: "some error", value: "some error value", error: true},
  ]

If error or warning is set true, error/warning icon is shown before value.
Separate error/warning shows error/warning message after data.
*/
export class InfoBox extends React.Component{

  constructor(props){
    super(props);
    this.state= {
      toggleOpen: false
    };
  }

  toggleOpen(){
    this.setState({
      toggleOpen: !this.state.toggleOpen
    });
  }

  render() {
    let errorMsg, warningMsg;

    if (this.props.error) {
      if(this.props.error === SERVER_TIMED_OUT)
        errorMsg = (
          <div className='info-container'>
            <div className="message">
              <div className="icon warn-red-icon"/>
              <p className='warning-text'>{ this.props.errorName }</p>
            </div>
            <Retry />
          </div>
        );
      else
        errorMsg = (
          <div className="message">
            <div className="icon error-icon"/>
            {this.props.error}
          </div>
      );
    }

    if (this.props.warning) {
      warningMsg = (
        <div className="message">
          <div className="icon warning-icon"/>
          {this.props.warning}
        </div>
      );
    }

    let content = _.map(this.props.data, (val, index) => {

      let valueCol = val.value;

      if (val.error) {
        valueCol = (
          <div className="message in-table">
            <div className="icon error-icon"/>
            {val.value}
          </div>
        );
      }

      if (val.warning) {
        valueCol = (
          <div className="message in-table">
            <div className="icon warning-icon"/>
            {val.value}
          </div>
        );
      }

      if (val.status === "on_load") {
        valueCol = (
          <LoadingLinear />
        );
      }


      return (
        <tr key={index}>
          <td className={"title " + val.name} id={"tdTitle" + val.name}>
            {('name' in val) ? `${val.name}` : ''}
          </td>
          <td className={val.status} id={"tdData" + val.name} style={{ wordBreak: "break-all" }}>
            {valueCol}
          </td>
        </tr>
      );
    });

    let showMoreButton = (
      <div className="show-more">
        <div className={"icon " + (this.state.toggleOpen ? "rotate" : "")}></div>
      </div>
    );

    return (
      <div
        className="info-box"
        onClick={() => this.toggleOpen()}
      >
        <table>
          <tbody>
          {content.length > MAX_NUMBER_OF_ROWS && !this.state.toggleOpen ? content.splice(0, MAX_NUMBER_OF_ROWS) : content}
          </tbody>
        </table>
        {warningMsg}
        {errorMsg}
        {this.props.data.length > MAX_NUMBER_OF_ROWS ? showMoreButton : undefined}
      </div>
    );
  }
}
